import { Controller } from 'stimulus'

export default class extends Controller {
    static targets = []

    open(e) {
        $(".hiw-item").removeClass('hiw-active')
        $(e.currentTarget).closest('.hiw-item').addClass('hiw-active')
        $(".hiw-img").addClass('hidden')
        $("#hiw-img-" + $(e.currentTarget).data('num')).removeClass('hidden')
    }
}
